import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ResearchReportTab } from "core/http/service/researchReport/resTypes";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: ResearchReportTab[];
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: [],
};

const getTabsContentSlice = createSlice({
  name: "getTabsContent",
  initialState,
  reducers: {
    getTabsContentStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getTabsContentSuccess: (
      state,
      action: PayloadAction<ResearchReportTab[]>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getTabsContentFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetTabsContentAvatar: () => {
      return { ...initialState };
    },
  },
});

export const {
  getTabsContentStart,
  getTabsContentSuccess,
  getTabsContentFailed,
  resetTabsContentAvatar,
} = getTabsContentSlice.actions;

export default getTabsContentSlice.reducer;
